import { styled } from "styled-components";

export const HomePageContainer = styled.div`
  text-align: center;
  padding: 2rem;
`;

export const Header = styled.header`
  background-color: #f2f2f2;
  padding: 2rem;
  border-radius: 8px;
  margin-bottom: 2rem;
`;

export const FeatureSection = styled.section`
  display: flex;
  justify-content: space-around;
  gap: 2rem;
`;

export const Feature = styled.div`
  background-color: #f9f9f9;
  padding: 2rem;
  border-radius: 8px;
  flex: 1;
  text-align: right;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;